export const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const REACT_APP_CRYPTOJS_SECRETKEY =
  process.env.REACT_APP_CRYPTOJS_SECRETKEY;
export const REACT_APP_CRYPTOJS_VECTOR = process.env.REACT_APP_CRYPTOJS_VECTOR;
export const REACT_APP_FILE_URL = process.env.REACT_APP_FILE_URL;
